import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        username: String,
        commentId: String
    }

    reply() {
        document.dispatchEvent(new CustomEvent("skinsort:reply-to-comment", {
            detail: {
                username: this.usernameValue,
                commentId: this.commentIdValue
            }
        }))
    }
}
